export default {
	route: {
		"home": "首页",
		"inquiry": "询价中心"
	},
	navbar: {

	},
	home: {
		"titleone": "为您获取最佳报价",
		"titletwo": "开始搜索、比较、预订和管理您的货运！",
		"origin": "起运地",
		"originDesc": "您要从哪里发货？",
		"destination": "目的地",
		"destinationDesc": "您要运送到哪里？",
		"load": "货物信息",
		"loadDesc": "您要运送什么？",
		"goods": "品名、货值和货好时间",
		"goodsDesc": "告诉我们您的商品信息",
		"addType": "类型",
		"addType_1": "港口/机场",
		"addType_2": "工厂/仓库",
		"addType_3": "亚马逊仓库",
		"addType_4": "商业地址",
		"addType_5": "私人地址",
		"addCountry": "国家",
		"Address": "地址",
		"AddPlhCode": "输入港口/机场代码",
		"AddPlhZip": "输入城市或邮政编码",
		"checkNoList" : "填写您的货运信息开始查价吧～",
		"checkHistory" : "查价历史",
		"checkEmpty" : "清空",
		"goodsName": "产品名称",
		"goodsTip": "不接受含有液体、粉末、仿牌、膏体等的所有违禁物品。若申报不实，一经发现，系统将扣件，并征收最高2000美元的赔偿。",
		"goodsMore": "了解更多",
		"goodsType": "您的货物中是否包含以下任何货物？",
		"goodsValue": "商品价值",
		"goodsValueTip": "您可以在商业发票上找到您的商品价值。",
		"goodsReadyTime": "您的货物准备好了吗？",
		"goodsReadyTimeTip": "请注意每张报价单上的有效期。如果您的货物在该日期前未入关，则费率可能会发生变化。",
		"goodsReadyTimeTip3" : "请注意，平台上的费率每两周更新一次。如果您的货物在有效期（见每张报价单）之后才准备就绪并入关，您的费率将与选择时的费率不同。",
		"goodsReady1": "货物已经准备就绪",
		"goodsReady2": "将在两周内准备就绪",
		"goodsReady3": "将在两周后准备就绪",
		"eachItem": "按每件货物填写",
		"eachTicket": "按每票货件填写",
	},
	common: {
		"confirm": "确认",
		"signin": "登录",
		"signup": "注册",
		"piece": "件",
		"sea": "海运",
		"air": "空运",
		"noData": "无数据",
		"pleaseEnter": "请输入",
		"pleaseSelect": "请选择",
		"shipments": "我的订单",
		"billing": "我的账单",
		"settings": "我的设置",
		"logout": "退出登陆",
	},
	login: {
		"submit": "登录",
		"title": "欢迎登录",
		"account": "账号",
		"accountPlaceholder": "输入您的登录名",
		"password": "密码",
		"passwordPlaceholder": "输入您的密码",
		"remenber": "记住用户",
		"forgotPwd": "忘记密码？",
		"toRegisterMsg": "没有帐户？",
		"toRegister": "去注册",
		"forgotTitle": "输入您的电子邮件地址，向您发送重置链接",
	}
}